import { useNavigate } from "react-router-dom";

export default function WhatIsSection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="lg:w-5/12">
            <span className="inline-block px-3 py-1 rounded-full border border-accent-200 bg-accent-50 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
              What is It
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-900 mb-2">
              What is an AllChinaBuy
            </h2>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-accent-600 mb-6">
              Spreadsheet?
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-5 text-sm md:text-base">
              An <strong>AllChinaBuy Spreadsheet</strong> is a carefully curated product database designed to help buyers discover trusted items, compare quality across sellers, and find reliable products quickly. Instead of spending hours scrolling through unverified listings, our spreadsheet organizes thousands of products across 14 categories — from <strong>Shoes</strong> and <strong>Hoodies</strong> to <strong>Bags</strong> and <strong>Accessories</strong> — all verified and updated on a weekly basis.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8 text-sm md:text-base">
              Whether you are a first-time buyer or an experienced shopper, the <strong>AllChinaBuy Spreadsheet</strong> gives you the confidence to make informed purchasing decisions with real seller ratings, price comparisons, and community-backed recommendations.
            </p>
            <button
              onClick={() => navigate("/best-allchinabuy-spreadsheet-guide")}
              className="inline-flex items-center gap-2 text-accent-600 font-semibold text-sm hover:text-accent-700 transition-colors duration-200 group cursor-pointer"
            >
              <span>Read the Full Guide</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
            </button>
          </div>

          <div className="lg:w-7/12 relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-2 flex gap-4 items-end">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20organized%20digital%20spreadsheet%20interface%20displayed%20on%20a%20modern%20laptop%20with%20warm%20ambient%20lighting%2C%20soft%20minimal%20workspace%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20editorial%20technology%20photography%2C%20gentle%20shadows%20from%20window%20light%2C%20professional%20yet%20cozy%20atmosphere%2C%20high%20detail&width=800&height=600&seq=whatis-v2-01-2026&orientation=landscape"
                  alt="AllChinaBuy Spreadsheet interface showing curated product database on laptop"
                  title="AllChinaBuy Spreadsheet — Curated Product Database Interface"
                  className="w-full h-48 md:h-56 object-cover object-top rounded-2xl"
                  loading="lazy"
                />
              </div>
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20curated%20fashion%20accessories%20including%20a%20leather%20bag%20sunglasses%20a%20watch%20and%20a%20silk%20scarf%20arranged%20on%20textured%20cream%20paper%2C%20soft%20window%20light%20casting%20gentle%20shadows%2C%20editorial%20lifestyle%20photography%2C%20warm%20sand%20and%20blush%20tones%2C%20sophisticated%20minimal%20composition&width=600&height=750&seq=whatis-v2-02-2026&orientation=portrait"
                alt="Curated fashion accessories collection from AllChinaBuy Spreadsheet"
                title="AllChinaBuy Spreadsheet Products — Verified Fashion Listings"
                className="w-full h-48 md:h-56 object-cover object-top rounded-2xl"
                loading="lazy"
              />
              <div className="flex flex-col gap-3">
                <div className="bg-background-100 rounded-2xl p-5 flex-1 flex flex-col justify-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-foreground-900 font-display">20,000+</div>
                  <div className="text-xs text-foreground-500 mt-1">Verified Products</div>
                </div>
                <div className="bg-accent-100 rounded-2xl p-5 flex-1 flex flex-col justify-center">
                  <div className="text-3xl md:text-4xl font-extrabold text-accent-600 font-display">Weekly</div>
                  <div className="text-xs text-accent-700 mt-1">Updates</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}